import { module } from 'modujs';
import NotLocomotiveScroll from '../classes/NotLocomotiveScroll'
import ScrollCall from '../classes/NotLocomotiveScroll/helpers/ScrollCall';
import ScrollTo from '../classes/NotLocomotiveScroll/helpers/ScrollTo';
import { lazyLoadImage } from '../utils/image';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        window.scrollTo(0,0);

        setTimeout(() => {
            this.initScrollInstance()
        }, 100)
    }

    initScrollInstance() {
        this.scrollInstance = new NotLocomotiveScroll(this.el, this.onScroll.bind(this))
        this.scrollInstance.start()

        this.onCall = this.onCall.bind(this)
        ScrollCall.on('call', this.onCall);
    }

    onCall(func,way,obj,id) {
        // Using modularJS
        this.call(func[0],{way,obj},func[1],func[2]);
    }

    scrollTo(args) {
        ScrollTo.goTo(args[0], args[1])
    }

    onScroll() {
        if(this.scrollInstance.scroll.direction == 1) {
            html.classList.add('is-scrolling-down')
        } else {
            html.classList.remove('is-scrolling-down')
        }

        if(window.scrollY > 80) {
            html.classList.add('has-scrolled');
        } else {
            html.classList.remove('has-scrolled');
        }
    }

    toggleNavSticky(e) {
        if(e.way === 'enter') {
            html.classList.add('has-nav-sticky-show')
        }

        if(e.way === 'exit') {
            html.classList.remove('has-nav-sticky-show')
        }
    }

    hideFilter(e) {
        if(e.way === 'enter') {
            html.classList.add('has-filter-hidden')
        }

        if(e.way === 'exit') {
            html.classList.remove('has-filter-hidden')
        }
    }

    footerVisible(e) {
        if(e.way === 'enter') {
            html.classList.add('has-footer-visible')
        }

        if(e.way === 'exit') {
            html.classList.remove('has-footer-visible')
        }
    }

    lazyLoad(args) {
        lazyLoadImage(args.obj.target)
    }

    resetScrollInstance() {
        this.destroyScrollInstance()

        requestAnimationFrame(() => {
            this.initScrollInstance()
        })
    }

    destroyScrollInstance() {
        this.scrollInstance.destroy()
    }

    destroy() {
        this.scrollInstance.destroy()
    }
}
